import { useEffect, useMemo, useState } from 'react';
import { Link2, Search, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export const ParentCornerPicker = ({ value, onChange, excludeId }) => {
  const { api } = useAuth();
  const [sims, setSims] = useState([]);
  const [q, setQ] = useState('');
  useEffect(() => {
    api().get('/simulations').then(({ data }) => setSims((data || []).filter(s => (s.format || 'corner') === 'corner' && s.id !== excludeId))).catch(() => {});
  }, [api, excludeId]);
  const selected = sims.find(s => s.id === value);
  const results = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return [];
    return sims.filter(s => `${s.project_name} ${s.retailer_name}`.toLowerCase().includes(t)).slice(0, 8);
  }, [q, sims]);

  return (
    <div className="space-y-2" data-testid="parent-corner-picker">
      <p className="text-sm font-medium text-slate-600 flex items-center gap-1.5"><Link2 className="w-4 h-4" />Corner parent (facultatif)</p>
      {value ? (
        <div className="flex items-center justify-between rounded-md border border-emerald-300 bg-emerald-50 px-3 py-2 text-sm" data-testid="parent-corner-selected">
          <span className="font-semibold text-emerald-800">{selected ? `${selected.project_name} (${selected.retailer_name})` : 'Corner lié'}</span>
          <button type="button" onClick={() => onChange(null)} className="text-emerald-700 hover:text-red-600" data-testid="parent-corner-clear"><X className="w-4 h-4" /></button>
        </div>
      ) : (
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input value={q} onChange={e => setQ(e.target.value)} placeholder="Rechercher un corner (nom du projet, enseigne…)"
            className="w-full h-10 pl-9 pr-3 rounded-md border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-orange-300" data-testid="parent-corner-search" />
          {results.length > 0 && (
            <div className="absolute z-20 mt-1 w-full rounded-md border bg-white shadow-lg max-h-64 overflow-y-auto">
              {results.map(s => (
                <button key={s.id} type="button" onClick={() => { onChange(s.id); setQ(''); }} data-testid={`parent-corner-option-${s.id}`}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-orange-50 transition-colors">
                  <span className="font-medium">{s.project_name}</span> <span className="text-slate-400">· {s.retailer_name}</span>
                </button>
              ))}
            </div>
          )}
          {q.trim() && results.length === 0 && <p className="text-xs text-slate-400 mt-1">Aucun corner trouvé</p>}
        </div>
      )}
    </div>
  );
};
